/**
 * Advantage Pak custom buy-box behaviour.
 *
 * Two plan radio cards (1-month, 3-month) + a single Add-to-Cart anchor.
 *
 * ON ADD-TO-CART (1-month / 3-month subscription)
 * ----------------------------------------------
 * Two-step AJAX flow (no page navigation):
 *   1. POST {shop}/cart/add.js      (items + selling_plan + upgrade gift)
 *   2. POST {shop}/cart/update.js   (discount=CODE1,CODE2 in form body)
 *   3. Refresh Dawn's <cart-drawer> section (GET ?section_id=cart-drawer)
 *   4. Open the cart drawer
 *
 * POST /cart/add.js request body (1-month):
 *   items[1][id]={variantId}
 *   &items[1][quantity]=1
 *   &items[1][selling_plan]=693518991662
 *   &items[2][id]=52538923417902     (the free Advantage Upgrade gift)
 *   &items[2][quantity]=1
 *
 * POST /cart/add.js request body (3-month):
 *   items[1][id]={variantId}
 *   &items[1][quantity]=3
 *   &items[1][selling_plan]=693519024430
 *   &items[2][id]=52538923417902
 *   &items[2][quantity]=1
 *
 * POST /cart/update.js request body:
 *   discount=ADVANTAGEUPGRADE        (1-month)
 *   discount=ADVANTAGEUPGRADE3       (3-month)
 *
 * ON BUY-ONCE
 * -----------
 * Builds a single GET URL on the buy-once <a>:
 *   {shop}/cart/add?items[1][id]={variantId}&items[1][quantity]=1&return_to=/cart
 * (No upgrade gift, no discount — straight to cart.)
 *
 * HARD-CODED DATA (set on .ap-buybox element in sections/main-product.liquid)
 * --------------------------------------------------------------------------
 *   data-cartbase            = "{{ shop.url }}/cart/add"
 *   data-upgrade-variant-id  = "52538923417902"   (free Advantage Upgrade gift)
 *   data-planone             = "693518991662"     (1-month selling plan)
 *   data-planthree           = "693519024430"     (3-month selling plan)
 *   data-d1a                 = ""                       (first discount slot — empty: 1-month uses only the upgrade)
 *   data-d1b                 = "ADVANTAGEUPGRADE"       (second discount slot — 1-month)
 *   data-d3a                 = "ADVANTAGEUPGRADE3"      (first discount slot — 3-month)
 *   data-d3b                 = ""                       (second discount slot — empty: 3-month uses only ADVANTAGEUPGRADE3)
 *
 * Discount slots are joined with `.filter(Boolean)` in `getDiscountCodes`,
 * so empty strings are skipped — single-discount plans only need one slot filled.
 *
 * EQUIVALENT STATIC-LINK URLS (for use as <a href> elsewhere on the site)
 * ----------------------------------------------------------------------
 * These do a full-page redirect chain (return_to → discount → cart) instead
 * of the AJAX flow above, but end with the same items + discounts in cart.
 *
 *   1-month subscription + upgrade + ADVANTAGEUPGRADE discount:
 *     {shop}/cart/add?items[1][id]={variantId}&items[1][quantity]=1
 *       &items[1][selling_plan]=693518991662
 *       &items[2][id]=52538923417902&items[2][quantity]=1
 *       &return_to=%2Fdiscount%2FADVANTAGEUPGRADE%3Fredirect%3D%252Fcart
 *
 *   3-month subscription + upgrade + ADVANTAGEUPGRADE3 discount:
 *     {shop}/cart/add?items[1][id]={variantId}&items[1][quantity]=3
 *       &items[1][selling_plan]=693519024430
 *       &items[2][id]=52538923417902&items[2][quantity]=1
 *       &return_to=%2Fdiscount%2FADVANTAGEUPGRADE3%3Fredirect%3D%252Fcart
 *
 * (Historical — 2-discount chains: ADVANTAGE+ADVANTAGEUPGRADE for 1-month,
 *  ADVANTAGE3PAK+ADVANTAGEUPGRADE for 3-month. See docs/ap-buybox.md
 *  history section for those URL shapes.)
 *
 *   Buy once (no upgrade gift, no discount):
 *     {shop}/cart/add?items[1][id]={variantId}&items[1][quantity]=1&return_to=/cart
 *
 * Plan state and variant state are kept in the buybox DOM and updated on
 * card-click and Dawn variant:change events.
 */
(function () {
  function getVariantId(buybox) {
    // 1. Prefer the form's hidden `name="id"` element (Dawn sets this
    // whenever the user selects a variant). Catches both <input name="id">
    // and <select name="id">. Most reliable source of truth.
    var form = document.querySelector(
      'form[action*="/cart/add"], form#product-form, form[id^="product-form"]'
    );
    if (form) {
      var idEl = form.querySelector('[name="id"]');
      if (idEl) {
        var val = idEl.value || (idEl.options && idEl.options[idEl.selectedIndex] && idEl.options[idEl.selectedIndex].value);
        if (val) return parseInt(val, 10);
      }
    }

    // 2. Read the currently-checked radio inside variant-radios. The browser
    // updates `checked` synchronously when the user clicks a radio, so this
    // is the most up-to-date source — even if Dawn's variant-radios state
    // getter (`radios.currentVariant`) hasn't propagated yet.
    var variantPickers = document.querySelectorAll('variant-radios, variant-selects');
    for (var i = 0; i < variantPickers.length; i++) {
      var picker = variantPickers[i];
      var checked = picker.querySelector('input[type="radio"]:checked, select option:checked');
      if (checked) {
        var json = picker.querySelector('script[type="application/json"]');
        if (json) {
          try {
            var variants = JSON.parse(json.textContent);
            // The radio's `value` is the human-readable title
            // (e.g., "Female Advantage"); match by title or by id-as-string.
            var match = variants.find(function (v) {
              return v.title === checked.value || String(v.id) === String(checked.value);
            });
            if (match) return match.id;
          } catch (e) {}
        }
        // If value is purely numeric, it's already the variant ID.
        if (/^\d+$/.test(checked.value)) return parseInt(checked.value, 10);
      }
    }

    // 3. Fallback: variant-radios' own currentVariant property.
    var radios = document.querySelector('variant-radios');
    if (radios && radios.currentVariant && radios.currentVariant.id) {
      return radios.currentVariant.id;
    }

    // 4. Last resort: data-default-variant-id (the page's first variant).
    if (buybox && buybox.dataset.defaultVariantId) {
      return parseInt(buybox.dataset.defaultVariantId, 10);
    }
    return null;
  }

  function listenVariantChange(callback) {
    function attach(el) {
      if (!el || el.__apBound) return;
      el.__apBound = true;
      el.addEventListener('variant:change', function (e) {
        var v = (e.detail && e.detail.variant) || el.currentVariant;
        if (v && v.id) callback();
      });
      // Listen for click events on the variant picker (radio / label).
      // Click events bubble even when the radio is later replaced by Dawn's
      // component re-render. Read currentVariant in a microtask so Dawn's
      // own click handler has had a chance to update the state first.
      el.addEventListener('click', function (e) {
        var t = e.target;
        if (t && (t.matches('input[type="radio"]') || t.matches('label') || t.closest('label'))) {
          Promise.resolve().then(callback);
        }
      });
    }
    attach(document.querySelector('variant-radios'));
    attach(document.querySelector('variant-selects'));
    // Last-resort fallback: a MutationObserver on document that watches for
    // ANY attribute change on the variant-radios element (or its descendants).
    // Catches cases where Dawn re-renders the picker and the variant:change
    // event gets lost in the re-mount.
    if (!document.__apVariantObserverBound) {
      document.__apVariantObserverBound = true;
      var observer = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var target = mutations[i].target;
          if (target.closest && (target.closest('variant-radios') || target.closest('variant-selects'))) {
            callback();
            return;
          }
        }
      });
      observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['checked', 'value']
      });
    }
  }

  function getSelectedPlan(buybox) {
    var card = buybox.querySelector('.ap-buybox__plan--selected');
    if (card) {
      var plan = card.getAttribute('data-ap-plan');
      if (plan) return plan;
    }
    var radio = buybox.querySelector('input[type="radio"][name="ap-plan"]:checked');
    return radio ? radio.value : '1mo';
  }

  function setSelectedPlan(buybox, plan) {
    var cards = buybox.querySelectorAll('.ap-buybox__plan');
    cards.forEach(function (card) {
      var matches = card.getAttribute('data-ap-plan') === plan;
      card.classList.toggle('ap-buybox__plan--selected', matches);
      card.setAttribute('aria-checked', matches ? 'true' : 'false');
      var input = card.querySelector('input[type="radio"]');
      if (input) input.checked = matches;
    });
  }

  function buildItemsBody(buybox, plan, variantId) {
    var data = buybox.dataset;
    if (!variantId) return null;
    var body = '';
    if (plan === '3mo') {
      body += 'items[1][id]=' + encodeURIComponent(variantId);
      body += '&items[1][quantity]=3';
      body += '&items[1][selling_plan]=' + encodeURIComponent(data.planthree);
    } else {
      body += 'items[1][id]=' + encodeURIComponent(variantId);
      body += '&items[1][quantity]=1';
      body += '&items[1][selling_plan]=' + encodeURIComponent(data.planone);
    }
    if (data.upgradeVariantId) {
      body += '&items[2][id]=' + encodeURIComponent(data.upgradeVariantId);
      body += '&items[2][quantity]=1';
    }
    return body;
  }

  function getDiscountCodes(buybox, plan) {
    var data = buybox.dataset;
    if (plan === '3mo') return [data.d3a, data.d3b].filter(Boolean);
    return [data.d1a, data.d1b].filter(Boolean);
  }

  /**
   * Re-render Dawn's <cart-drawer> after the cart has been mutated via AJAX.
   * Dawn's own pattern: fetch the cart-drawer section HTML and update the
   * drawer's #CartDrawer and the cart-icon-bubble element.
   */
  async function refreshCartDrawer() {
    var origin = window.location.origin;
    var res = await fetch(origin + '/cart?section_id=cart-drawer', {
      method: 'GET',
      credentials: 'same-origin',
      headers: { 'Accept': 'text/html' }
    });
    if (!res.ok) return;
    var html = await res.text();
    var doc = new DOMParser().parseFromString(html, 'text/html');
    // Update #CartDrawer
    var sourceCart = doc.getElementById('CartDrawer');
    var targetCart = document.getElementById('CartDrawer');
    if (sourceCart && targetCart) {
      targetCart.innerHTML = sourceCart.innerHTML;
    }
    // Update the cart-icon-bubble counter
    var sourceBubble = doc.getElementById('cart-icon-bubble');
    var targetBubble = document.getElementById('cart-icon-bubble');
    if (sourceBubble && targetBubble) {
      targetBubble.innerHTML = sourceBubble.innerHTML;
    }
    // Update any cart-drawer-items subcomponent
    var drawerItems = document.querySelector('cart-drawer-items');
    if (drawerItems && sourceCart) {
      var newItems = sourceCart.querySelector('cart-drawer-items');
      if (newItems) drawerItems.innerHTML = newItems.innerHTML;
    }
    // Mark the drawer as not-empty
    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      drawer.classList.remove('is-empty');
      var inner = drawer.querySelector('.drawer__inner');
      if (inner) inner.classList.remove('is-empty');
    }
  }

  function openCartDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
    } else {
      // Fallback: add the classes manually if Dawn's JS isn't initialized
      var fallback = document.getElementById('CartDrawer');
      if (fallback) {
        fallback.classList.add('animate', 'active');
        document.body.classList.add('overflow-hidden');
      }
    }
  }

  /**
   * AJAX add-to-cart for the 1-month and 3-month deals.
   * Two POSTs: first add the items, then apply the discount codes.
   * After both succeed, refresh the cart drawer and open it (no navigation).
   */
  async function addToCartSubscription(buybox, plan) {
    var variantId = getVariantId(buybox);
    if (!variantId) {
      window.alert('Please select a variant first.');
      return;
    }
    var itemsBody = buildItemsBody(buybox, plan, variantId);
    var codes = getDiscountCodes(buybox, plan);
    if (!itemsBody) return;
    var origin = window.location.origin;

    var btn = buybox.querySelector('[data-ap-buy="add_to_cart"]');
    if (btn) {
      btn.setAttribute('aria-busy', 'true');
      btn.style.opacity = '0.6';
      btn.style.pointerEvents = 'none';
    }

    try {
      // Step 1: add items + selling plan
      var addRes = await fetch(origin + '/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Accept': 'application/json'
        },
        body: itemsBody
      });
      if (!addRes.ok) {
        var addErr = await addRes.json().catch(function () { return {}; });
        throw new Error('Add to cart failed: ' + (addErr.description || addRes.statusText));
      }

      // Step 2: apply the discount codes
      if (codes.length) {
        var codesJoined = codes.join(',');
        var updateRes = await fetch(origin + '/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Accept': 'application/json'
          },
          body: 'discount=' + encodeURIComponent(codesJoined)
        });
        if (!updateRes.ok) {
          console.warn('Discount apply failed', updateRes.status, updateRes.statusText);
        }
      }

      // Step 3: refresh the slideout cart drawer with the new state
      await refreshCartDrawer();

      // Step 4: open the slideout cart drawer (no full-page navigation)
      openCartDrawer();
    } catch (err) {
      console.error('ap-buybox addToCart error:', err);
      window.alert('Could not add to cart: ' + (err && err.message || 'Unknown error'));
    } finally {
      if (btn) {
        btn.removeAttribute('aria-busy');
        btn.style.opacity = '';
        btn.style.pointerEvents = '';
      }
    }
  }

  function buildUrlForBuyOnce(buybox) {
    var data = buybox.dataset;
    var variantId = getVariantId(buybox);
    if (!variantId) return '#';
    var url = data.cartbase + '?items[1][id]=' + encodeURIComponent(variantId) + '&items[1][quantity]=1&return_to=/cart';
    return url;
  }

  function applyBuyOnceHref(buybox) {
    var buyOnce = buybox.querySelector('[data-ap-buy="buy_once"]');
    if (!buyOnce) return;
    // Update the href attribute for accessibility/no-JS users and hover preview.
    var href = buildUrlForBuyOnce(buybox);
    if (href && href !== '#') buyOnce.setAttribute('href', href);
    // Bind a click handler (once) that uses AJAX to add the variant to cart
    // and opens the slideout cart drawer — no full-page navigation. Reads the
    // currently-selected variant fresh at click time so the destination is
    // always correct, regardless of whether variant:change fired earlier.
    if (!buyOnce.__apBuyOnceBound) {
      buyOnce.__apBuyOnceBound = true;
      buyOnce.addEventListener('click', function (e) {
        e.preventDefault();
        var variantId = getVariantId(buybox);
        if (!variantId) return;
        var origin = window.location.origin;
        buyOnce.setAttribute('aria-busy', 'true');
        buyOnce.style.opacity = '0.6';
        buyOnce.style.pointerEvents = 'none';
        fetch(origin + '/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Accept': 'application/json'
          },
          body: 'items[1][id]=' + encodeURIComponent(variantId) + '&items[1][quantity]=1'
        })
        .then(function (res) {
          if (!res.ok) throw new Error('Add to cart failed: ' + res.statusText);
          return refreshCartDrawer();
        })
        .then(function () { openCartDrawer(); })
        .catch(function (err) {
          console.error('ap-buybox buy-once error:', err);
          // Last-resort fallback: navigate to /cart so the customer isn't stuck.
          window.location.href = '/cart';
        })
        .finally(function () {
          buyOnce.removeAttribute('aria-busy');
          buyOnce.style.opacity = '';
          buyOnce.style.pointerEvents = '';
        });
      });
    }
  }

  function wireCard(buybox, card) {
    function select() {
      var plan = card.getAttribute('data-ap-plan');
      if (plan) setSelectedPlan(buybox, plan);
    }
    var input = card.querySelector('input[type="radio"]');
    if (input) input.addEventListener('change', select);
    card.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        select();
      }
    });
  }

  function init() {
    var buyboxes = document.querySelectorAll('.ap-buybox');
    if (!buyboxes.length) return;
    buyboxes.forEach(function (buybox) {
      var cards = buybox.querySelectorAll('.ap-buybox__plan');
      cards.forEach(function (card) {
        wireCard(buybox, card);
      });
      var btn = buybox.querySelector('[data-ap-buy="add_to_cart"]');
      if (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          var plan = getSelectedPlan(buybox);
          addToCartSubscription(buybox, plan);
        });
      }
      applyBuyOnceHref(buybox);
    });

    listenVariantChange(function () {
      document.querySelectorAll('.ap-buybox').forEach(applyBuyOnceHref);
    });

    [50, 200, 600].forEach(function (delay) {
      setTimeout(function () {
        document.querySelectorAll('.ap-buybox').forEach(applyBuyOnceHref);
      }, delay);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
